/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setEyeOpeningResponseOptions } from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'

export function* getEyeOpeningResponseOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const eyeOpeningResponse: IOptionsResponse = yield call([vitalsService, vitalsService.getEyeOpeningResponse])
    const { entity } = eyeOpeningResponse
    yield put(setEyeOpeningResponseOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getEyeOpeningResponseOptions() error: ${e}`))
  }
}

export function* getEyeOpeningResponseOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getEyeOpeningResponseOptions)
}
